
<template>
  <LayoutCenter>
    <div class="font-serif text-3xl">This page could not be found.</div>
  </LayoutCenter>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LayoutCenter from '@/components/LayoutCenter.vue';

export default defineComponent({
  name: 'NotFound',
  components: {
    LayoutCenter,
  },
});
</script>
